import { morphSection } from '@theme/section-renderer';

// Keeps the free gift in the cart in step with the threshold: exactly one when the cart qualifies, none otherwise.
// The state comes from `snippets/cart-rewards.liquid`, which re-renders on every cart change.
if (!customElements.get('free-gift-sync')) {
  const MAX_SYNCS_PER_PAGE = 6;
  let busy = false;
  let syncs = 0;

  customElements.define(
    'free-gift-sync',
    class FreeGiftSync extends HTMLElement {
      static observedAttributes = ['data-state'];

      connectedCallback() {
        this.sync();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== null && oldValue !== newValue) this.sync();
      }

      async sync() {
        const { variantId, sectionId, qualifies, quantity } = this.dataset;
        const target = qualifies === 'true' ? 1 : 0;
        if (!variantId || Number(quantity || 0) === target) return;
        if (busy || syncs >= MAX_SYNCS_PER_PAGE) return;

        busy = true;
        syncs += 1;
        this.classList.add('is-loading');
        try {
          const sections = sectionId ? [sectionId] : [];
          const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [variantId]: target }, sections }),
          });
          if (!response.ok) throw new Error('Free gift cart update failed');
          const data = await response.json();

          document.querySelectorAll('[data-cart-count]').forEach((badge) => {
            badge.textContent = String(data.item_count);
            badge.hidden = data.item_count === 0;
          });

          busy = false;
          const html = data.sections?.[sectionId];
          if (html) await morphSection(sectionId, html);
        } catch (error) {
          console.error(error);
        } finally {
          busy = false;
          this.classList.remove('is-loading');
        }
      }
    }
  );
}
